@if (!!href) {
  <a class="link--no-underline" [attr.href]="href" [attr.target]="getOpenInNewTab">
    <ng-container *ngTemplateOutlet="content"></ng-container>

    @if (openInNewTab) {
      <ftr-icon [icon]="'OpenInNew'" [size]="'Small'" [align]="'Sub'" [gapLeft]="'Small'"></ftr-icon>
    }
  </a>
} @else {
  <a
    class="link--no-underline"
    (click)="openLink.emit()"
    [routerLink]="getRouterLink"
    [target]="getOpenInNewTab"
    [queryParams]="getQueryParams"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>

    @if (openInNewTab) {
      <ftr-icon [icon]="'OpenInNew'" [size]="'Small'" [align]="'Sub'" [gapLeft]="'Small'"></ftr-icon>
    }
  </a>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
